import React from 'react';
import styled from 'styled-components';
import { TextButton } from '../../Button';
import { BREAKPOINTS, COLORS } from '../../styles';
import { Size } from '../../types';
import { MenuButton } from '../types';
import {useMediaMatch} from "rooks";

const ActionContainer = styled.div`
  padding: 8px 16px;
  box-sizing: border-box;
  border-top: 1px solid ${props => COLORS.getColor('neutral_200', props.theme)};
  display: flex;
  flex-direction: column;

  ${BREAKPOINTS.SMALL} {
    padding: 16px;
  }
`;

interface MobileActionContainerProps extends MenuButton {}

export const MobileActionContainer: React.FunctionComponent<MobileActionContainerProps> = ({ disabled, variant = 'secondary', icon, label, loading, action }) => {
  const isSmallScreen = useMediaMatch(BREAKPOINTS.SMALL.replace('@media ', ''));

  return (
    <ActionContainer>
      <TextButton variant={variant} size={isSmallScreen ? Size.Medium : Size.Small} disabled={disabled} icon={icon} loading={loading} onClick={action}>
        {label}
      </TextButton>
    </ActionContainer>
  );
};
